import React, { Component, Fragment } from 'react'
import { FormGroup, ControlLabel, FormControl, Row, Col, Button, Form, InputGroup } from 'react-bootstrap'
import { makeUniqueKey } from '../helper'
import ExtraLeagueInfo from './extraLeagueInfo'
import AddCoach from './addCoach'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faInfoCircle, faTimes } from '@fortawesome/free-solid-svg-icons'
import VirtualizedSelect from 'react-virtualized-select'


const discountReasons = [
  <option key={makeUniqueKey()} value="" disabled selected>Select</option>,
  <option key='multi-player' value="multi-player">Multi-player</option>,
  <option key='multi-team' value="multi-team" >Multi-team</option>,
  <option key='multi-program' value="multi-program">Multi-program</option>
]

const discountTypes = [
  <option key={makeUniqueKey()} value="" disabled selected>Select</option>,
  <option key='percentage' value="%">%</option>,
  <option key='dollar' value="$" >$</option>,
]

class PricingTab extends Component {
  constructor(props) {
    super();

    const item_0_cost = props.defaultPlaceholders.item_0_cost;
    const item_1_cost = props.defaultPlaceholders.item_1_cost;
    const item_2_cost = props.defaultPlaceholders.item_2_cost;

    const hasMerch = (typeof item_0_cost !== 'undefined' && item_0_cost !== null) ||
                    (typeof item_1_cost !== 'undefined' && item_1_cost !== null) ||
                    (typeof item_2_cost !== 'undefined' && item_2_cost !== null);

    this.state = {
      addMerch:  !!hasMerch,
      merchHint: false,
      planHint: false,
      addDiscounts: false,
      discounts: [],
      showDiscHead: false,
      enrolHint: false,
      maxHint: false,
      flexHint: false,
      profitHint: false,
      showProfitCalculator: false
    }
  }

  renderMerch = () => {
    var merch_arr = []
    var rthis = this
    this.props.organization_merch.forEach((merch, index) => {
      merch_arr.push(
        <Col sm={4}>
          <FormGroup>
            <ControlLabel>{merch.name} price</ControlLabel>
            <FormControl 
              className="opaque-grey"
              name={`item_${index}_cost`}
              id={`item_${index}_cost`}
              type="number"
              min="0"
              defaultValue={eval(`rthis.props.defaultPlaceholders.item_${index}_cost`)}
            />
          </FormGroup>
        </Col>)
    })
    return merch_arr
  }

  addDiscount = () => {
    console.log('adding discount')
    var tempDiscounts = this.state.discounts
    if(document.getElementById("discount_reason").value === "select" || document.getElementById("discount_type").value === "select" || document.getElementById("threshold").value === "" || document.getElementById("discount_value").value === ""){
        alert("Please enter all the fields in session")
    } else {
      tempDiscounts.push({
        reason: document.getElementById("discount_reason").value,
        threshold: document.getElementById("threshold").value,
        type: document.getElementById("discount_type").value,
        value: document.getElementById("discount_value").value
      });
      this.setState({ addDiscounts: false, discounts: tempDiscounts }, ()=> console.log('discount plans', this.state.discounts));
    }
  }

  removeDiscount = (clicked) => {
    var i = clicked.target.value
    var tempDiscounts = this.state.discounts.slice()
    tempDiscounts.splice(i, 1)
    this.setState({ discounts: tempDiscounts })
  }

  handleChange = (val, index, field) => {
    var tempDiscounts = this.state.discounts.slice()
    // console.log('tempDiscounts in handleChange', tempDiscounts)
    switch (field) {
      case 'reason':
        tempDiscounts[index].reason = val.target.value
        break
      case 'threshold':
        tempDiscounts[index].threshold = val.target.value
        break
      case 'type':
        tempDiscounts[index].type = val.target.value
        break
      case 'value':
        tempDiscounts[index].value = val.target.value
        break
      default:
        alert('invalid form field')
    }
    this.setState({ discounts: tempDiscounts })
  }


  renderDiscounts = () => {
    var addControl = null;
    if (this.state.addDiscounts) {
      addControl =
        <div>
          <Col sm={3}>
            <FormGroup>
              <FormControl className="opaque-grey" name="discount_reason" componentClass="select" id="discount_reason" disabled={this.props.disabled}>
                {discountReasons}
              </FormControl>
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <FormControl className="opaque-grey" name="threshold" type="number" min="0" max="10" id="threshold"/>
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <FormControl className="opaque-grey" name="discount_type" componentClass="select" id="discount_type">
                {discountTypes}
              </FormControl>
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup className="form-group-options">
              <InputGroup>
                <FormControl className="opaque-grey" name="discount_value" type="number" min="0" id="discount_value"/>
                <InputGroup.Button>
                  <Button className="orange-outline" onClick={this.addDiscount}>Save</Button>
                </InputGroup.Button>
              </InputGroup>
              <a onClick={() => this.setState({ addDiscounts: false })}><FontAwesomeIcon icon={faTimes} size="1x" color='white' /></a>
            </FormGroup>
          </Col>
      </div>
    } else {
      addControl =
      <Col sm={3}>
        <Button className="orange-outline" onClick={() => this.setState({ addDiscounts: true, showDiscHead: true })}>Add Checkout Discounts</Button>
      </Col>
    }
    return (
      <div>
        {this.state.discounts.map((input, index) => {
          console.log('rendering each discount', index, ': ', input )
          return (
            <div>
              <Col sm={3}>
                <FormGroup>
                  <FormControl className="opaque-grey" componentClass="select" value={input.reason} onChange={(val)=> this.handleChange(val, index, 'reason')}>
                    {discountReasons}
                  </FormControl>
                </FormGroup>
              </Col>
              <Col sm={3}>
                <FormGroup>
                  <FormControl className="opaque-grey" type="number" min="0" max="10" value={input.threshold}onChange={(val)=> this.handleChange(val, index, 'threshold')}/>
                </FormGroup>
              </Col>
              <Col sm={3}>
                <FormGroup>
                  <FormControl className="opaque-grey" componentClass="select" value={input.type} onChange={(val)=> this.handleChange(val, index, 'type')}>
                    {discountTypes}
                  </FormControl>
                </FormGroup>
              </Col>
              <Col sm={3}>
                <FormGroup className="form-group-options">
                  <InputGroup>
                    <FormControl className="opaque-grey" type="number" min="0" value={input.value} onChange={(val)=> this.handleChange(val, index, 'value')}/>
                    <InputGroup.Button>
                      <Button className="orange-outline" value={index} onClick={this.removeDiscount}>Delete</Button>
                    </InputGroup.Button>
                  </InputGroup>
                </FormGroup>
              </Col>
            </div>
          )
        })}
        {addControl}
      </div>
    )
  }

  render() {
    const {
      defaultPlaceholders,
      renderSubmitButtons,
      renderPlans,
      calculateProjectedProfits, 
      notifyFormChange,
      league,
      disabled,
      showHint,
      udfHint,
      programUDFs,
      handleUDFs,
      orgUDFS,
      coachSelectOptions,
      selectedCoachValues,
      handleCoachSelectionChange,
      disabled: pricingDisabled,
      plans,
      planMap,
      availablePlanOptions,
      priceMap,
      selectedProfitPlan,
      handleProfitPlanChange,
    } = this.props
  return (
    <div onBlur={notifyFormChange}>
      <div className="coloured-modal program-modal-tab-pane">          
              <Row>
               <Col sm={6} xs={12}>
               <h3>Pricing</h3>               
                <Row>
                  <Col sm={12} xs={12}>
                    <FormGroup>
                      <div className="flex flex-row gap-1">
                        <div>Event Fees</div>
                        <a className="heading-hint" onClick={() => this.setState({ planHint: !this.state.planHint })}>
                          <FontAwesomeIcon icon={faInfoCircle} color='white'/>
                          {
                            this.state.planHint ?
                          <div className="hint-tip-text" id="payment-hint">
                            <span>Setup pricing from Plans page.</span>
                          </div>
                          : ''
                          }
                        </a>
                      </div>
                      {renderPlans('new_plan', 'enrollment_goal', 'expected_costs', 'projected_program_profits','plans')}
                    </FormGroup>  
                    </Col>                
                </Row>
                </Col>
                <Col sm={6} xs={12}>
                  {!league && (
                    <AddCoach
                      coachSelectOptions={coachSelectOptions}
                      selectedCoachValues={selectedCoachValues}
                      handleCoachSelectionChange={handleCoachSelectionChange}
                      disabled={pricingDisabled}
                    />
                  )}
                </Col>
              </Row>
              <hr/>
              <Row>
                <Col sm={6} xs={12}>
                  <h3>Registration Rules</h3>
                  <Row>
                    <Col sm={4}>
                      <FormGroup>
                        <ControlLabel>Reg Goal</ControlLabel>
                        <FormControl className="opaque-grey" name="enrollment_goal" type="number" min="0" id="enrollment_goal" defaultValue={defaultPlaceholders.enrollment_goal} onChange={() => calculateProjectedProfits('enrollment_goal', 'expected_costs', 'projected_program_profits', selectedProfitPlan)} disabled={disabled}/>
                      </FormGroup>
                    </Col>
                    <Col sm={4}>
                      <FormGroup>
                        <div className="flex flex-row gap-1">
                          <div>Reg Maximum</div>
                          <a className="hint-tip" onClick={() => this.setState({ maxHint: !this.state.maxHint })}>
                            <FontAwesomeIcon icon={faInfoCircle} color='white'/>
                            {
                              this.state.maxHint ?
                            <div className="hint-tip-text" id="name-hint">
                              <span>When the Reg Max is reached the status changes from OPEN to WAITLIST - OPEN.
                              </span>
                            </div>
                            : ''
                            }
                          </a>
                        </div>
                        <FormControl className="opaque-grey" name="enrollment_maximum" type="number" min="0" id={"enrollment_maximum"} defaultValue={defaultPlaceholders.enrollment_maximum} disabled={disabled}/>
                      </FormGroup>
                    </Col>
                    <Col sm={4}>
                      <FormGroup>
                        <div className="flex flex-row gap-1">
                          <div>Reg Flex</div>
                          <a className="hint-tip" onClick={() => this.setState({ flexHint: !this.state.flexHint })}>
                            <FontAwesomeIcon icon={faInfoCircle} color='white'/>
                            {
                              this.state.flexHint ?
                            <div className="hint-tip-text" id="name-hint">
                              <span>The number of players in excess of the Reg Max that can accept invitations from the waitlist
                              </span>
                            </div>
                            : ''
                            }
                          </a>
                        </div>
                        <FormControl className="opaque-grey" name="enrolment_flex" type="number" min="0" id={"enrolment_flex"} defaultValue={defaultPlaceholders.enrolment_flex} disabled={disabled}/>
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
                {orgUDFS && !league && (
                  <Col sm={6} xs={12}>
                    <div className="flex flex-row gap-1 item-center">
                      <h3>Sell Merchandise</h3>
                      <a className="heading-hint" onClick={() => this.setState({ merchHint: !this.state.merchHint })}>
                            <FontAwesomeIcon icon={faInfoCircle} color='white' />
                            {
                              this.state.merchHint ?
                            <div className="hint-tip-text" id="payment-hint">
                              <span>
                                Enter an item's price to sell it on the enrolment form.  Enter price as 0 to mark it as an inclusion.
                                Leave price blank and the item will not display on the enrolment form
                                </span>
                            </div>
                            : ''
                            }
                      </a>
                    </div>
                    <Row>
                      {this.renderMerch()}
                    </Row>
                  </Col>
                )}
              </Row>
              <hr/>
              <Row>
                <Col sm={6} xs={12}>
                  {this.state.showProfitCalculator ? (
                    <div className="profit-calculator-card">
                      <div className="flex flex-row gap-1 item-center">
                        <h3>Profit Calculator</h3>
                        <Button
                          className="cancel-option profit-calculator-toggle"
                          onClick={() => this.setState({ showProfitCalculator: false })}
                        >
                          Hide Profit Calculator
                        </Button>
                        <a className="heading-hint" onClick={() => this.setState({ profitHint: !this.state.profitHint })}>
                          <FontAwesomeIcon icon={faInfoCircle} color='white'/>
                          {
                            this.state.profitHint ?
                          <div className="hint-tip-text" id="name-hint">
                            <span>Projected Profits = Plan x Reg Goal - Expected Costs
                            </span>
                          </div>
                          : ''
                          }
                        </a>
                      </div>
                      <div className="profit-calculator-formula">
                        <span className="profit-calculator-term">Projected Profits</span>
                        <span className="profit-calculator-symbol">=</span>
                        <span className="profit-calculator-term">Plan x Reg Goal</span>
                        <span className="profit-calculator-symbol">-</span>
                        <span className="profit-calculator-term">Expected Costs</span>
                      </div>
                      <div className="profit-calculator-note">
                        Projected profits update automatically when Reg Goal or Expected Costs changes.
                      </div>
                      <FormGroup className="profit-calculator-plan-select">
                        <ControlLabel>Plan to compare</ControlLabel>
                        <FormControl
                          className="opaque-grey"
                          componentClass="select"
                          id="profit_calculator_plan"
                          value={selectedProfitPlan || ''}
                          onChange={handleProfitPlanChange}
                          disabled={disabled || !plans || plans.length === 0}
                        >
                          <option value="" disabled>{plans && plans.length > 0 ? 'Select a plan' : 'No plans added'}</option>
                          {plans && plans.length > 0 && plans.map((planId) => (
                            <option key={planId} value={planId}>
                              {planMap[planId]} - {priceMap[planId]}
                            </option>
                          ))}
                        </FormControl>
                      </FormGroup>
                      <div className="profit-calculator-selected">
                        {selectedProfitPlan && planMap[selectedProfitPlan]
                          ? `Using ${planMap[selectedProfitPlan]} - ${priceMap[selectedProfitPlan]}`
                          : 'Select a plan to preview projected profits.'}
                      </div>
                      <Row className="profit-calculator-row">
                        <Col sm={6}>
                          <FormGroup>
                            <ControlLabel>Expected Costs</ControlLabel>
                            <FormControl className="opaque-grey" name="expected_costs" type="number" min="0" id={"expected_costs"} defaultValue={defaultPlaceholders.expected_costs} onChange={() => calculateProjectedProfits('enrollment_goal', 'expected_costs', 'projected_program_profits', selectedProfitPlan)} disabled={disabled}/>
                          </FormGroup>
                        </Col>
                        <Col sm={6}>
                          <FormGroup>
                            <ControlLabel>Projected Profits</ControlLabel>
                            <FormControl disabled placeholder="Automatically calculated" className="opaque-grey" name="projected_program_profits" type="number" min="0" id={"projected_program_profits"} defaultValue={defaultPlaceholders.projected_program_profits}/>
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    <Button
                      className="add-session-btn"
                      onClick={() => this.setState({ showProfitCalculator: true })}
                    >
                      Show Profit Calculator
                    </Button>
                  )}
                </Col>
              </Row>
              <hr/>

          {/* { this.state.addMerch ?
            <Fragment>
              <h3>Merchandise Sales
                <a className="heading-hint" onClick={() => this.setState({ merchHint: !this.state.merchHint })}>
                  <FontAwesomeIcon icon={faInfoCircle} color='white' style={{ padding: '0.2em'}}/>
                  {
                    this.state.merchHint ?
                  <div className="hint-tip-text" id="payment-hint">
                    <span>Enter an item's price to sell it on the enrolment form.  Enter price as 0 to mark it as an inclusion. Leave price blank and the item will not display on the enrolment form</span>
                  </div>
                  : ''
                  }
                </a>
              </h3>
              <Row>
                {this.renderMerch()}
              </Row>
              <Row style={{marginBottom: '1em'}}>
                <Col sm={3}>
                  <Button className="button2" bsStyle="primary" onClick={() => this.setState({addMerch: !this.state.addMerch })}>Cancel Merchandise</Button>
                </Col>
              </Row>
            </Fragment>
            : 
            <Row style={{marginBottom: '1em'}}>
              <Col sm={3}>
                <Button className="button2" bsStyle="primary" onClick={() => this.setState({addMerch: !this.state.addMerch })} disabled={disabled}>Sell Merchandise</Button>
              </Col>
            </Row>
          } */}

                <Row className="btn-flex">
                  {renderSubmitButtons()}
                </Row>
      </div>
    </div>
  )
}
}

export default PricingTab
